import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProjectService } from '@app/services/project/project.service';
import { UserDto } from '@api/users/interfaces';
import { map, switchMap, tap } from 'rxjs/operators';
import { UserRestService } from '@app/services/rest/user-rest.service';
import { ActivatedRoute } from '@angular/router';
import { MenuService } from '@app/services/menu';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-project-roles',
	templateUrl: './user-project-roles.component.html',
	styleUrls: ['../user-pages.style.scss'],
})
export class UserProjectRolesComponent implements OnInit, OnDestroy {

	public user: UserDto;

	private subscription: Subscription = new Subscription();

	constructor(private activatedRoute: ActivatedRoute,
				private projectService: ProjectService,
				private userRestService: UserRestService,
				private menuService: MenuService,
				private translateService: TranslateService,
	)
	{ }

	ngOnInit(): void {
		this.subscription.add(
			this.activatedRoute.paramMap.pipe(map(paramMap => paramMap.get('username')),
				switchMap(username => this.userRestService.userByUsername$(username)),
				tap(userDto => this.user = userDto),
				switchMap(user => this.translateService.stream('user.editroles.title', {username: user.username})),
				tap(result => this.menuService.title = result)
			).subscribe()
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}
